/* import __COLOCATED_TEMPLATE__ from './document-title.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentTitle extends Component {}
